import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const DONE = 'done'

/**
 * Form model
 */
const formModel = () => {
  return {
    [DONE]: {
      label: `Done`,
      name: DONE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [DONE]: false,
}


export default formModel
